import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    Modal,
    BubbleSelectBlock,
    DateInput, MessageCard,
    NumberInput,
    Services,
    Text,
    TextInput
} from '@simplybenefits/sb-ui-library';
import pdfImg from '../../../../assets/pdf.png';
import { validateDentistForEDI } from '../../../../actions/adjudication.js';
import {
    validateBirthdate,
    validateFirstName,
    validateLastName,
    validatePolicyNumber,
    validateCertificate
} from '../../../../util/dental.js';

class ClaimMetaInputModal extends PureComponent {
    state = {
        payee: this.props.meta.payee || '',
        dentist: this.props.meta.dentist || '',
        officePostalCode: this.props.meta.officePostalCode || '',
        patient: this.props.meta.patient || '',
        cert: this.props.meta.cert || '',
        includesOrthodontic: this.props.meta.includesOrthodontic,
        secondaryCoverage: this.props.meta.secondaryCoverage,
        checkForMaxillary: this.props.meta.checkForMaxillary,
        checkForMandibular: this.props.meta.checkForMandibular,
        isUpperPlacement: this.props.meta.isUpperPlacement,
        dateOfUpperPlacement: this.props.meta.dateOfUpperPlacement || null,
        dateOfLowerPlacement: this.props.meta.dateOfLowerPlacement || null,
        isLowerPlacement: this.props.meta.isLowerPlacement,
        totalAmountOfService: this.props.meta.totalAmountOfService || '',
        totalBenefitAmount: this.props.meta.totalBenefitAmount || '',
        deductibleAmount: this.props.meta.deductibleAmount || '',
        totalPayable: this.props.meta.totalPayable || '',
        cobPrimaryMetaGroupNum: this.props.meta.cobPrimaryMetaGroupNum || '',
        cobPrimaryMetaCert: this.props.meta.cobPrimaryMetaCert || '',
        cobPrimaryMetaRelationship: this.props.meta.cobPrimaryMetaRelationship || '',
        cobPrimaryMetaBirthdate: this.props.meta.cobPrimaryMetaBirthdate || '',
        cobPrimaryMetaProvince: this.props.meta.cobPrimaryMetaProvince || '',
        cobPrimaryMetaFirstname: this.props.meta.cobPrimaryMetaFirstname || '',
        cobPrimaryMetaLastname: this.props.meta.cobPrimaryMetaLastname || '',
        loadedCert: this.props.meta.cert || null,
        patientOptions: [],
        dentistValidated: null,
        loadedDocumentCount: (this.props.documents || []).filter((doc) => doc.contentType === 'application/pdf').length
    };

    _bottomRef = React.createRef();

    _scrollToButtons = () => this._bottomRef.current.scrollIntoView();

    _setPatientOptions() {
        const dependents = this.props.userData.dependents.map((dependent) => ({
            name: `${ dependent.firstname } ${ dependent.lastname } (${ dependent.relationship })`,
            id: dependent.dependentID
        }));

        const primary = {
            name: `${ this.props.userData.meta.firstname } ${ this.props.userData.meta.lastname }`,
            id: this.props.userData.meta.userID
        };

        let newPatientOptions = [ primary, ...dependents ];

        if (this.props.userData.meta.patient && !this.props.meta.patient) {
            this.props.meta.patient = this.props.userData.meta.patient;
        }

        // if the member is under Survivor Benefit status then ensure we add a way to claim for the deceased primary cert
        if (this.props.userData.meta.status === 11) {
            const deceasedCert = {
                name: 'Deceased Primary Cert',
                id: this.props.userData.meta.userID
            };

            newPatientOptions = [ deceasedCert, ...dependents ];
        }

        return this.setState({
            patientOptions: newPatientOptions,
            patient: this.props.meta.patient ? this.props.meta.patient : newPatientOptions[0],
            loadedCert: this.props.userData.meta.cert,
            payee: this.props.meta.payee || '',
            dentist: this.props.meta.dentist || '',
            officePostalCode: this.props.meta.officePostalCode || '',
            secondaryCoverage: this.props.meta.secondaryCoverage,
            includesOrthodontic: this.props.meta.includesOrthodontic,
            checkForMaxillary: this.props.meta.checkForMaxillary,
            checkForMandibular: this.props.meta.checkForMandibular,
            isUpperPlacement: this.props.meta.isUpperPlacement,
            dateOfUpperPlacement: this.props.meta.dateOfUpperPlacement,
            dateOfLowerPlacement: this.props.meta.dateOfLowerPlacement,
            isLowerPlacement: this.props.meta.isLowerPlacement,
            cert: this.props.userData.meta.cert,
            certError: false,
            payeeError: false,
            patientError: false,
            dentistError: false,
            officePostalCodeError: false,
            totalAmountOfService: this.props.meta.totalAmountOfService || '',
            totalBenefitAmount: this.props.meta.totalBenefitAmount || '',
            deductibleAmount: this.props.meta.deductibleAmount || '',
            totalPayable: this.props.meta.totalPayable || '',
            cobPrimaryMetaGroupNum: this.props.meta.cobPrimaryMetaGroupNum || '',
            cobPrimaryMetaCert: this.props.meta.cobPrimaryMetaCert || '',
            cobPrimaryMetaRelationship: this.props.meta.cobPrimaryMetaRelationship || '',
            cobPrimaryMetaBirthdate: this.props.meta.cobPrimaryMetaBirthdate || '',
            cobPrimaryMetaProvince: this.props.meta.cobPrimaryMetaProvince || '',
            cobPrimaryMetaFirstname: this.props.meta.cobPrimaryMetaFirstname || '',
            cobPrimaryMetaLastname: this.props.meta.cobPrimaryMetaLastname || ''
        });
    }

    componentDidMount() {
        if (this.props.userData) {
            this._setPatientOptions();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!this.props.userData) {
            return null;
        }

        if (prevState.patient !== this.state.patient
            || prevState.cobPrimaryMetaFirstname !== this.state.cobPrimaryMetaFirstname
            || prevState.cobPrimaryMetaLastname !== this.state.cobPrimaryMetaLastname
            || prevState.cobPrimaryMetaRelationship !== this.state.cobPrimaryMetaRelationship
            || prevState.cobPrimaryMetaProvince !== this.state.cobPrimaryMetaProvince
        ) {
            this._saveData();
        }

        if (this.state?.loadedCert !== this.props?.userData?.meta?.cert) {
            this._setPatientOptions();
        }

        // When documents arrive asynchronously after mount, PDFs won't fire onLoad so re-count them here
        if (prevProps.documents !== this.props.documents) {
            const pdfCount = (this.props.documents || []).filter((doc) => doc.contentType === 'application/pdf').length;
            this.setState({ loadedDocumentCount: pdfCount });
        }

        return null;
    }

    _selectDropdown = (type, event) => {
        this.setState({
            [type]: event.target.value
        });
    };

    _selectPatient = (event) => {
        this.setState({
            patient: this.state.patientOptions.find((e) => e.name === event.target.value)
        });
    };

    _saveData = () => {
        this.props.saveData({
            ...this.props.meta,
            patient: this.state.patient,
            cert: this.state.cert,
            payee: this.state.payee,
            dentist: this.state.dentist,
            officePostalCode: this.state.officePostalCode,
            includesOrthodontic: this.state.includesOrthodontic,
            secondaryCoverage: this.state.secondaryCoverage,
            checkForMaxillary: this.state.checkForMaxillary,
            checkForMandibular: this.state.checkForMandibular,
            isUpperPlacement: this.state.isUpperPlacement,
            dateOfUpperPlacement: this.state.dateOfUpperPlacement,
            dateOfLowerPlacement: this.state.dateOfLowerPlacement,
            isLowerPlacement: this.state.isLowerPlacement,
            totalAmountOfService: this.state.totalAmountOfService,
            totalBenefitAmount: this.state.totalBenefitAmount,
            deductibleAmount: this.state.deductibleAmount,
            totalPayable: this.state.totalPayable,
            cobPrimaryMetaGroupNum: this.state.cobPrimaryMetaGroupNum,
            cobPrimaryMetaCert: this.state.cobPrimaryMetaCert,
            cobPrimaryMetaRelationship: this.state.cobPrimaryMetaRelationship,
            cobPrimaryMetaBirthdate: this.state.cobPrimaryMetaBirthdate,
            cobPrimaryMetaProvince: this.state.cobPrimaryMetaProvince,
            cobPrimaryMetaFirstname: this.state.cobPrimaryMetaFirstname,
            cobPrimaryMetaLastname: this.state.cobPrimaryMetaLastname
        }, 'meta');
    };

    _validateForm = async () => {
        const certError = await Services.validateInput('checkEmpty', this.state.cert);
        const payeeError = this.props.isPredetermination ? false : await Services.validateInput('checkEmpty', this.state.payee);
        const patientError = await Services.validateInput('checkEmpty', this.state.patient);
        const dentistError = await Services.validateInput('checkEmpty', this.state.dentist);
        const officePostalCodeError = await Services.validateInput('checkEmpty', this.state.officePostalCode);

        const includesOrthodonticError = this.state.includesOrthodontic === null;
        const secondaryCoverageError = this.state.secondaryCoverage === null;
        const checkForMaxillaryError = this.state.checkForMaxillary === null;
        const checkForMandibularError = this.state.checkForMandibular === null;

        let dateOfUpperPlacementError = false;
        let dateOfLowerPlacementError = false;

        if (this.state.isUpperPlacement === false) {
            dateOfUpperPlacementError = await Services.validateInput('checkEmpty', this.state.dateOfUpperPlacement || '');
        }

        if (this.state.isLowerPlacement === false) {
            dateOfLowerPlacementError = await Services.validateInput('checkEmpty', this.state.dateOfLowerPlacement || '');
        }

        let totalAmountOfServiceError = null;
        let totalBenefitAmountError = null;
        let deductibleAmountError = null;
        let totalPayableError = null;
        let cobPrimaryMetaGroupNumError = null;
        let cobPrimaryMetaCertError = null;
        let cobPrimaryMetaRelationshipError = null;
        let cobPrimaryMetaBirthdateError = null;
        let cobPrimaryMetaProvinceError = null;
        let cobPrimaryMetaFirstnameError = null;
        let cobPrimaryMetaLastnameError = null;

        if (this.props.isCOB) {
            totalAmountOfServiceError = await Services.validateInput('checkEmpty', this.state.totalAmountOfService);
            totalBenefitAmountError = await Services.validateInput('checkEmpty', this.state.totalBenefitAmount);
            deductibleAmountError = await Services.validateInput('checkEmpty', this.state.deductibleAmount);
            totalPayableError = await Services.validateInput('checkEmpty', this.state.totalPayable);
            cobPrimaryMetaGroupNumError = validatePolicyNumber(this.state.cobPrimaryMetaGroupNum);
            cobPrimaryMetaCertError = validateCertificate(this.state.cobPrimaryMetaCert);
            cobPrimaryMetaRelationshipError = await Services.validateInput('checkEmpty', this.state.cobPrimaryMetaRelationship);
            cobPrimaryMetaBirthdateError = validateBirthdate(this.state.cobPrimaryMetaBirthdate);
            cobPrimaryMetaProvinceError = await Services.validateInput('checkEmpty', this.state.cobPrimaryMetaProvince);
            cobPrimaryMetaFirstnameError = validateFirstName(this.state.cobPrimaryMetaFirstname);
            cobPrimaryMetaLastnameError = validateLastName(this.state.cobPrimaryMetaLastname);
        }

        this.setState({
            certError,
            payeeError,
            patientError,
            dentistError,
            officePostalCodeError,
            totalAmountOfServiceError,
            totalBenefitAmountError,
            deductibleAmountError,
            totalPayableError,
            includesOrthodonticError,
            secondaryCoverageError,
            checkForMaxillaryError,
            checkForMandibularError,
            dateOfUpperPlacementError,
            dateOfLowerPlacementError,
            cobPrimaryMetaGroupNumError,
            cobPrimaryMetaCertError,
            cobPrimaryMetaRelationshipError,
            cobPrimaryMetaBirthdateError,
            cobPrimaryMetaProvinceError,
            cobPrimaryMetaFirstnameError,
            cobPrimaryMetaLastnameError
        });

        if (certError || payeeError || officePostalCodeError || dentistError || officePostalCodeError ||
            totalAmountOfServiceError || totalBenefitAmountError || deductibleAmountError || totalPayableError ||
            includesOrthodonticError || secondaryCoverageError || checkForMaxillaryError || checkForMandibularError ||
            dateOfUpperPlacementError || dateOfLowerPlacementError || cobPrimaryMetaGroupNumError ||
            cobPrimaryMetaCertError || cobPrimaryMetaRelationshipError || cobPrimaryMetaBirthdateError ||
            cobPrimaryMetaProvinceError || cobPrimaryMetaFirstnameError || cobPrimaryMetaLastnameError
        ) {
            return false;
        }

        return true;
    };

    _validateDentist = async () => {
        const valid = await this._validateForm();

        if (!valid) {
            return;
        }

        const dentistValidated = await this.props.dispatch(validateDentistForEDI(this.state.dentist, this.state.officePostalCode));

        this.setState({
            dentistValidated
        });

        this._scrollToButtons();
    };

    _next = async () => {
        const valid = await this._validateForm();

        if (!valid) {
            return;
        }

        this._saveData();
        this.props.next();
    };

    _handleChange = (key, e, isValue = false) => {
        this.setState({
            [key]: isValue ? e : e.target.value
        });
    };

    _getPrimaryButton = () => {
        const documentsLoading = this.props.documents?.length > 0 && this.state.loadedDocumentCount < this.props.documents.length;

        if (this.state.loadedCert) {
            if (this.props.isPredetermination || this.state.dentistValidated !== null) {
                return {
                    label: "Next",
                    onClick: this._next,
                    disabled: documentsLoading
                };
            }

            return {
                label: "Validate Dentist",
                onClick: this._validateDentist,
                disabled: documentsLoading
            };
        }

        return {
            label: "Load Member",
            onClick: () => this.props.getCertInfo(this.state.cert)
        };

    };

    render() {
        return (
            <Modal
                medium={ this.state.loadedCert }
                testid="submit-claim-modal"
                aria-labelledby="Submit Claim"
                open={true}
                title={ this.props.title }
                primaryButton={ this._getPrimaryButton() }
                onClose={ this.props.onClose}
                loader={ this.props.loader }
            >
                {
                    this.props.documents?.length > 0 &&
                        <div style={{ marginBottom: 16 }}>
                            <Text bold medium>Uploaded Documents</Text>

                            {
                                this.props.documents.map((doc, i) => {
                                    const isPDF = doc.contentType === 'application/pdf';

                                    return (
                                        <div key={i} style={{ marginTop: 10 }}>
                                            <Text small light>{ doc.isReceipt ? 'Receipt' : doc.filename }</Text>

                                            <a href={ doc.url } target="_blank" rel="noreferrer">
                                                <img
                                                    alt={ doc.filename }
                                                    src={ isPDF ? pdfImg : doc.url }
                                                    style={{ height: 200, width: 'auto', display: 'block', marginTop: 6, cursor: 'pointer' }}
                                                    onLoad={ isPDF ? undefined : () => this.setState((prev) => ({ loadedDocumentCount: prev.loadedDocumentCount + 1 })) }
                                                />
                                            </a>
                                        </div>
                                    );
                                })
                            }
                        </div>
                }

                {
                    Boolean(this.props.reasonsForFlagging && this.props.reasonsForFlagging.length) &&
                        <div style={{ marginBottom: 10 }}>
                            <Text bold medium margin="0 0 10px 0">Reasons for Review</Text>

                            {
                                this.props.reasonsForFlagging.map((reason) => <Text small>{ reason }</Text>)
                            }
                        </div>
                }

                <Text bold medium margin="10px 0 0 0">Details</Text>

                <TextInput
                    label="Certificate"
                    variant="outlined"
                    value={this.state.cert}
                    onChange={(e) => {
                        this.setState({
                            cert: e.target.value
                        });
                    }}
                    required
                    fullWidth
                    error={Boolean(this.state.certError)}
                    helperText={this.state.certError}
                    disabled={Boolean(this.state.loadedCert)}
                />

                {
                    this.state.loadedCert &&
                            <React.Fragment>
                                <TextInput
                                    label="Select Patient"
                                    variant="outlined"
                                    value={ this.state.patient?.name }
                                    onChange={(event) => this._selectPatient(event)}
                                    required
                                    select
                                    fullWidth
                                    selectOptions={this.state.patientOptions.map((e) => e.name)}
                                    error={Boolean(this.state.patientError)}
                                    helperText={this.state.patientError}
                                />

                                <TextInput
                                    label="Dentist Name"
                                    variant="outlined"
                                    value={this.state.dentist}
                                    onChange={ (e) => this._handleChange('dentist', e) }
                                    onBlur={() => {
                                        this.setState({
                                            dentistValidated: null
                                        });
                                    }}
                                    required
                                    fullWidth
                                    error={Boolean(this.state.dentistError)}
                                    helperText={this.state.dentistError}
                                    disabled={ this.props.meta.isEdiDentist }
                                />

                                <TextInput
                                    label="Office Postal Code"
                                    variant="outlined"
                                    value={this.state.officePostalCode}
                                    onChange={ (e) => this._handleChange('officePostalCode', e) }
                                    onBlur={() => {
                                        this.setState({
                                            dentistValidated: null
                                        });
                                    }}
                                    required
                                    fullWidth
                                    error={Boolean(this.state.officePostalCodeError)}
                                    helperText={this.state.officePostalCodeError}
                                    disabled={ this.props.meta.isEdiDentist }
                                />

                                {
                                    !this.props.isPredetermination &&
                                        <>
                                            <Text small margin="10px 0 0 0">
                                                Select whether to pay the member or pay the dentist?
                                            </Text>

                                            <BubbleSelectBlock
                                                first={{
                                                    title: 'Pay Member',
                                                    selected: this.state.payee === 'member',
                                                    field: 'member'
                                                }}
                                                second={{
                                                    title: 'Pay Dentist',
                                                    selected: this.state.payee === 'dentist',
                                                    field: 'dentist'
                                                }}
                                                handleChange={ (field) => this.setState({ payee: field }) }
                                            />

                                            {
                                                this.state.payeeError &&
                                                    <Text tiny color="red" margin="-5px 0 0 15px">
                                                        { this.state.payeeError }
                                                    </Text>
                                            }
                                        </>
                                }

                                <Text small margin="10px 0 0 0">
                                    Does the service include Orthodontic procedures?
                                </Text>

                                <BubbleSelectBlock
                                    first={{
                                        title: 'Yes',
                                        selected: this.state.includesOrthodontic === true,
                                        field: 'yes'
                                    }}
                                    second={{
                                        title: 'No',
                                        selected: this.state.includesOrthodontic === false,
                                        field: 'no'
                                    }}
                                    handleChange={ (field) => this.setState({ includesOrthodontic: field === 'yes' }) }
                                />

                                {
                                    this.state.includesOrthodonticError &&
                                        <Text tiny color="red" margin="-5px 0 0 15px">
                                            Please select a value
                                        </Text>
                                }

                                <Text small margin="10px 0 0 0">
                                    Does the patient have secondary coverage?
                                </Text>

                                <BubbleSelectBlock
                                    first={{
                                        title: 'Yes',
                                        selected: this.state.secondaryCoverage === true,
                                        field: 'yes'
                                    }}
                                    second={{
                                        title: 'No',
                                        selected: this.state.secondaryCoverage === false,
                                        field: 'no'
                                    }}
                                    handleChange={ (field) => this.setState({ secondaryCoverage: field === 'yes' }) }
                                />

                                {
                                    this.state.secondaryCoverageError &&
                                        <Text tiny color="red" margin="-5px 0 0 15px">
                                            Please select a value
                                        </Text>
                                }

                                <Text small margin="10px 0 0 0">
                                    Does the visit include an Upper Denture, Crown or Bridge?
                                </Text>

                                <BubbleSelectBlock
                                    first={{
                                        title: 'Yes',
                                        selected: this.state.checkForMaxillary === true,
                                        field: 'yes'
                                    }}
                                    second={{
                                        title: 'No',
                                        selected: this.state.checkForMaxillary === false,
                                        field: 'no'
                                    }}
                                    handleChange={ (field) => {
                                        if (field === 'no') {
                                            this.setState({
                                                isUpperPlacement: null
                                            });
                                        }

                                        this.setState({ checkForMaxillary: field === 'yes' });
                                    }}
                                />

                                {
                                    this.state.checkForMaxillaryError &&
                                        <Text tiny color="red" margin="-5px 0 0 15px">
                                            Please select a value
                                        </Text>
                                }

                                {
                                    this.state.checkForMaxillary &&
                                        <React.Fragment>
                                            <Text small margin="10px 0 0 0">
                                                Is this an Initial Placement Upper?
                                            </Text>

                                            <BubbleSelectBlock
                                                first={{
                                                    title: 'Yes',
                                                    selected: this.state.isUpperPlacement === true,
                                                    field: 'yes'
                                                }}
                                                second={{
                                                    title: 'No',
                                                    selected: this.state.isUpperPlacement === false,
                                                    field: 'no'
                                                }}
                                                handleChange={ (field) => this.setState({ isUpperPlacement: field === 'yes' })}
                                            />

                                            {
                                                this.state.isUpperPlacement === false &&
                                                    <DateInput
                                                        label="Date of Initial Placement Upper"
                                                        variant="outlined"
                                                        value={ this.state.dateOfUpperPlacement }
                                                        onChange={ (e) => this.setState({ dateOfUpperPlacement: e.target.value }) }
                                                        required
                                                        fullWidth
                                                        error={Boolean(this.state.dateOfUpperPlacementError)}
                                                        helperText={this.state.dateOfUpperPlacementError}
                                                    />
                                            }
                                        </React.Fragment>
                                }

                                <Text small margin="10px 0 0 0">
                                    Does the visit include a Lower Denture, Crown or Bridge?
                                </Text>

                                <BubbleSelectBlock
                                    first={{
                                        title: 'Yes',
                                        selected: this.state.checkForMandibular === true,
                                        field: 'yes'
                                    }}
                                    second={{
                                        title: 'No',
                                        selected: this.state.checkForMandibular === false,
                                        field: 'no'
                                    }}
                                    handleChange={ (field) => {
                                        if (field === 'no') {
                                            this.setState({
                                                isLowerPlacement: null
                                            });
                                        }

                                        this.setState({ checkForMandibular: field === 'yes' });
                                    }}
                                />

                                {
                                    this.state.checkForMandibularError &&
                                        <Text tiny color="red" margin="-5px 0 0 15px">
                                            Please select a value
                                        </Text>
                                }

                                {
                                    this.state.checkForMandibular &&
                                        <React.Fragment>
                                            <Text small margin="10px 0 0 0">
                                                Is this an Initial Placement Lower?
                                            </Text>

                                            <BubbleSelectBlock
                                                first={{
                                                    title: 'Yes',
                                                    selected: this.state.isLowerPlacement === true,
                                                    field: 'yes'
                                                }}
                                                second={{
                                                    title: 'No',
                                                    selected: this.state.isLowerPlacement === false,
                                                    field: 'no'
                                                }}
                                                handleChange={ (field) => this.setState({ isLowerPlacement: field === 'yes' })}
                                            />

                                            {
                                                this.state.isLowerPlacement === false &&
                                                    <DateInput
                                                        label="Date of Initial Placement Lower"
                                                        variant="outlined"
                                                        value={ this.state.dateOfLowerPlacement }
                                                        onChange={ (e) => this.setState({ dateOfLowerPlacement: e.target.value }) }
                                                        required
                                                        fullWidth
                                                        error={Boolean(this.state.dateOfLowerPlacementError)}
                                                        helperText={this.state.dateOfLowerPlacementError}
                                                    />
                                            }
                                        </React.Fragment>
                                }

                                {
                                    this.props.isCOB &&
                                        <React.Fragment>
                                            <Text mediumLarge bold margin="10px 0">
                                                Explanation of Benefit Details
                                            </Text>

                                            <TextInput
                                                label="Policy Number"
                                                variant="outlined"
                                                value={this.state.cobPrimaryMetaGroupNum}
                                                onChange={ (e) => this._handleChange('cobPrimaryMetaGroupNum', e) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.cobPrimaryMetaGroupNumError)}
                                                helperText={this.state.cobPrimaryMetaGroupNumError}
                                            />

                                            <TextInput
                                                label="Certificate Number"
                                                variant="outlined"
                                                value={this.state.cobPrimaryMetaCert}
                                                onChange={ (e) => this._handleChange('cobPrimaryMetaCert', e) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.cobPrimaryMetaCertError)}
                                                helperText={this.state.cobPrimaryMetaCertError}
                                            />

                                            <TextInput
                                                label="Firstname"
                                                variant="outlined"
                                                value={this.state.cobPrimaryMetaFirstname}
                                                onChange={(event) => this._selectDropdown('cobPrimaryMetaFirstname', event)}
                                                required
                                                fullWidth
                                                error={Boolean(this.state.cobPrimaryMetaFirstnameError)}
                                                helperText={this.state.cobPrimaryMetaFirstnameError}
                                            />

                                            <TextInput
                                                label="Lastname"
                                                variant="outlined"
                                                value={this.state.cobPrimaryMetaLastname}
                                                onChange={(event) => this._selectDropdown('cobPrimaryMetaLastname', event)}
                                                required
                                                fullWidth
                                                error={Boolean(this.state.cobPrimaryMetaLastnameError)}
                                                helperText={this.state.cobPrimaryMetaLastnameError}
                                            />

                                            <DateInput
                                                label="Birthdate"
                                                variant="outlined"
                                                value={ this.state.cobPrimaryMetaBirthdate }
                                                onChange={ (e) => this.setState({ cobPrimaryMetaBirthdate: e.target.value }) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.cobPrimaryMetaBirthdateError)}
                                                helperText={this.state.cobPrimaryMetaBirthdateError}
                                            />

                                            <TextInput
                                                label="Relationship"
                                                variant="outlined"
                                                value={this.state.cobPrimaryMetaRelationship}
                                                onChange={(event) => this._selectDropdown('cobPrimaryMetaRelationship', event)}
                                                select
                                                required
                                                fullWidth
                                                selectOptions={[ 'Spouse', 'Common Law', 'Child', 'Self', 'Other' ]}
                                                error={Boolean(this.state.cobPrimaryMetaRelationshipError)}
                                                helperText={this.state.cobPrimaryMetaRelationshipError}
                                            />

                                            <TextInput
                                                label="Province"
                                                variant="outlined"
                                                value={this.state.cobPrimaryMetaProvince}
                                                onChange={(event) => this._selectDropdown('cobPrimaryMetaProvince', event)}
                                                select
                                                required
                                                fullWidth
                                                selectOptions={Services.selectFieldOptions.provinceOptions()}
                                                error={Boolean(this.state.cobPrimaryMetaProvinceError)}
                                                helperText={this.state.cobPrimaryMetaProvinceError}
                                            />

                                            <NumberInput
                                                prefix="$"
                                                label="Total Amount of Service"
                                                variant="outlined"
                                                value={ this.state.totalAmountOfService }
                                                onChange={ (e) => this._handleChange('totalAmountOfService', e) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.totalAmountOfServiceError)}
                                                helperText={this.state.totalAmountOfServiceError}
                                            />

                                            <NumberInput
                                                prefix="$"
                                                label="Total Benefit Amount"
                                                variant="outlined"
                                                value={ this.state.totalBenefitAmount }
                                                onChange={ (e) => this._handleChange('totalBenefitAmount', e) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.totalBenefitAmountError)}
                                                helperText={this.state.totalBenefitAmountError}
                                            />

                                            <NumberInput
                                                prefix="$"
                                                label="Total Deductible Amount"
                                                variant="outlined"
                                                value={ this.state.deductibleAmount }
                                                onChange={ (e) => this._handleChange('deductibleAmount', e) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.deductibleAmountError)}
                                                helperText={this.state.deductibleAmountError}
                                            />

                                            <NumberInput
                                                prefix="$"
                                                label="Total Payable"
                                                variant="outlined"
                                                value={ this.state.totalPayable }
                                                onChange={ (e) => this._handleChange('totalPayable', e) }
                                                required
                                                fullWidth
                                                error={Boolean(this.state.totalPayableError)}
                                                helperText={this.state.totalPayableError}
                                            />
                                        </React.Fragment>
                                }
                            </React.Fragment>
                }

                <Text light tiny>
                    By submitting this claim I agree to the Simply Benefits Terms of Service.
                </Text>

                {
                    this.state.payee.toUpperCase() === 'DENTIST' && this.state.dentistValidated === false
                        ? <MessageCard
                            isError={true}
                            title="Dentist Validation Failed - Cheque Payment Required"
                            subtitle="The provided dentist could not be validated with EDI. Auto payment through Instream will not be triggered and a cheque payment will be required."
                        />
                        : null
                }

                {
                    this.state.payee.toUpperCase() !== 'DENTIST' && this.state.dentistValidated === false
                        ? <MessageCard
                            isError={true}
                            title="Member Reimbursement"
                            subtitle="The provided dentist could not be validated with EDI. However, the payee is set to Member so a member reimbursement will be created for this claim."
                        />
                        : null
                }

                {
                    this.state.payee.toUpperCase() === 'DENTIST' && this.state.dentistValidated?.paymentType === 'DirectPay'
                        ? <MessageCard
                            title="Dentist Validated - Payment through EDI"
                            subtitle="The provided dentist was validated successfully with EDI. The payment will be auto sent through Instream. No cheque payment is required."
                        />
                        : null
                }

                {
                    this.state.payee.toUpperCase() === 'DENTIST' && this.state.dentistValidated?.paymentType === 'Cheque'
                        ? <MessageCard
                            isError={true}
                            title="Dentist Validated - Cheque Payment Required"
                            subtitle="The provided dentist was validated successfully with EDI. However, direct payment is not available. Auto payment through Instream will not be triggered and a cheque payment will be required."
                        />
                        : null
                }

                {
                    this.state.payee.toUpperCase() !== 'DENTIST' && this.state.dentistValidated
                        ? <MessageCard
                            title="Member Reimbursement"
                            subtitle="The payee is set to Member so a member reimbursement will be created for this claim."
                        />
                        : null
                }
                <div ref={this._bottomRef}></div>
            </Modal>
        );
    }
}

export default connect()(ClaimMetaInputModal);